<template>
  <div class="component__checkout h-100">
    <b-form-group class="mb-0">
      <template #label>
        <b-form-checkbox-group
          id="items"
          ref="cart__items-list"
          name="items"
          class="cart__items-list"
          stacked
        >
          <div
            v-for="(item, index) in learningUnitOptions"
            :key="`item__index-${index}`"
            :ref="`item__index-${index}`"
          >
            <div class="row__mc-item">
              <div
                :key="`thumbnail--${item.id}`"
                :ref="`item__index-${index}-img`"
                class="cart__thumbnail"
              >
                <b-img
                  class="rounded img__learning-unit"
                  :src="
                    item.learning_unit.media_detail && item.learning_unit.media_detail[0]
                      ? item.learning_unit.media_detail[0].url
                      : require('@/assets/default-lu-cover.jpg')
                  "
                >
                </b-img>
              </div>
              <div class="row__mc-details">
                <div class="text__mc-details">
                  <div
                    :ref="`item__index-${index}-text-mc-name`"
                    class="text__mc-name font-size-md text-black p-0"
                  >
                    {{ item.learning_unit.name }}
                  </div>
                  <b-badge
                    :ref="`item__index-${index}-text-mc-type`"
                    pill
                    variant="secondary"
                    class="text__type"
                  >
                    {{ displayMode(item) }}
                  </b-badge>
                </div>

                <div class="right-content">
                  <div :ref="`item__index-${index}-text-mc-price`" class="text__mc-details-price">
                    <price-displayer
                      ref="priceDisplayerComponent"
                      class="text__mc-price"
                      style="display: flex-end"
                      :class="{ 'text__mc-price-discount': item.discount_price != null }"
                      :normal-price="item.price"
                      :discount-price="item.discount_price"
                      is-currency-form
                      :is-show-normal-price="true"
                      :is-uppercase="true"
                    >
                    </price-displayer>
                  </div>
                  <div class="button__redeem">
                    <RedeemAction
                      :learning-unit-id="item.learning_unit.id"
                      :redirect-url="getRedirectUrl(item)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-form-checkbox-group>
      </template>
    </b-form-group>

    <div v-if="totalAmount" class="block__order-checkout">
      <ReceiptForm ref="receiptForm" @submit:receipt-form="handleReceiptFormSubmit" />
      <PaymentMethodSelector
        ref="paymentMethodSelector"
        v-model="$_selectedPayment"
        class="block__order-detail"
        :total-amount="totalAmount"
      />
    </div>
  </div>
</template>

<script>
import PriceDisplayer from '@/views/LearningUnitExplore/components/PriceDisplayer';
import PaymentMethodSelector from '@/views/Payment/components/PaymentMethodSelector';
import { formatPaymentMethodMixin } from '@/mixins/formatPaymentMethodMixin';
import { formatPriceMixin } from '@/mixins/formatPriceMixin';
import ReceiptForm from './ReceiptForm.vue';

export default {
  name: 'Checkout',

  components: {
    PriceDisplayer,
    PaymentMethodSelector,
    ReceiptForm,
    RedeemAction: () => import('./RedeemAction.vue')
  },

  mixins: [formatPaymentMethodMixin, formatPriceMixin],

  props: {
    learningUnitOptions: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      textMode: {
        VERIFY: 'Verify',
        LEARN_VERIFY: 'Verify + Learn'
      },
      selectedPayment: 'QR_PAYMENT'
    };
  },

  computed: {
    $_selectedPayment: {
      get() {
        return this.selectedPayment;
      },

      set(value) {
        this.selectedPayment = value;
      }
    },

    // cartItems() {
    //   return this.$_selected.length
    //     ? CartItem.query()
    //         .whereId(this.$_selected)
    //         .with('cart')
    //         .with('learning_unit')
    //         .with('learning_unit_option')
    //         .orderBy('created_at', 'desc')
    //         .get()
    //     : [];
    // },

    price() {
      const { learningUnitOptions = [] } = this;

      let sum = 0;

      if (learningUnitOptions.length) {
        sum = learningUnitOptions.reduce((prev, curr) => {
          return prev + curr.price;
        }, 0);
      }

      return sum;
    },

    totalAmount() {
      const { learningUnitOptions = [] } = this;

      let sum = 0;

      if (learningUnitOptions.length) {
        sum = learningUnitOptions.reduce((prev, curr) => {
          return curr.discount_price == null ? prev + curr.price : prev + curr.discount_price;
        }, 0);
      }

      this.$emit('update:totalAmount', sum);
      return sum;
    },
    redirectUrl() {
      return this.$route.query.previousPath || null;
    }
  },
  methods: {
    getRedirectUrl(item) {
      if (this.redirectUrl) {
        return this.redirectUrl;
      }
      return `/micro-credentials/detail/${item.learning_unit.id}`;
    },
    handleReceiptFormSubmit(receiptForm) {
      this.$emit('submit:receipt-form', receiptForm);
    },
    isQuota(item) {
      if (item.option_type == 'QUOTA') {
        return true;
      } else {
        return false;
      }
    },
    onSelectedPayment() {
      this.$emit('update:selectedPayment', this.totalAmount > 0 ? this.selectedPayment : null);

      if (this.$refs['paymentMethodSelector']) {
        this.$refs['paymentMethodSelector'].$v.$touch();
      }
    },
    displayMode(option) {
      const textMode = {
        VERIFY_ENTRY: 'Verify',
        LEARN_VERIFY_ENTRY: 'Verify + Learn',
        VERIFY_QUOTA: 'Quota',
        LEARN_VERIFY_QUOTA: 'Learn + Quota'
      };

      return textMode[`${option.mode}_${option.option_type}`];
    }
  }
};
</script>

<style lang="scss">
.row__mc-item {
  display: grid;
  grid-template-columns: 200px auto;
  grid-gap: 20px;
}

.row__mc-details {
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-gap: 20px;
}

@media screen and (max-width: 520px) {
  .row__mc-item {
    grid-template-columns: 1fr;
  }
  .row__mc-details {
    grid-template-columns: 1fr;
  }
  .text__mc-price {
    float: left !important;
  }
  .text__type {
    margin-top: 8px;
  }
}

@media screen and (min-width: 521px) and (max-width: 767px) {
  .row__mc-details {
    grid-template-columns: 2fr 1fr;
  }
  .text__mc-details-price {
    .text__mc-price > * {
      margin: 0 !important;
      float: right;
    }
  }
}

.cart__thumbnail {
  position: relative;
  overflow: hidden;
  aspect-ratio: auto;
  // min-width: 160px;
  width: 200px;
  height: 125px;

  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    object-fit: var(--object-fit);
  }
}
.block__order-checkout {
  display: grid;
  gap: 20px;
}

.row__mc-details {
  .text__mc-name {
    font-size: 20px;
    font-weight: 700;
    color: #3b3e66;
  }
  .badge {
    width: max-content;
    text-transform: none;
  }

  .text__type {
    display: flex;
    align-items: center;
    color: #07091980;
    border: 1px solid #d1d2db80;
    border-radius: 10.4px;
    padding: 12px 14px;
    font-size: 14px;
  }

  .text__mc-details-price > * {
    float: right;
  }

  .text__mc-price-normal {
    color: rgba(7, 9, 25, 0.5);
    font-weight: 400 !important;
    float: right;
  }

  .text__mc-price-discount {
    color: var(--primary);
    float: right;
  }

  .text__mc-price-discount del {
    text-decoration-color: var(--primary);
    opacity: 1 !important;
    color: rgba(7, 9, 25, 0.5);
  }

  .text__mc-details {
    display: grid;
    gap: 8px;
    align-content: space-between;
  }
  .right-content {
    display: flex;
    flex-direction: column;
  }
}
</style>
